<template>
  <div>
    <h1>采摘报表</h1>
  </div>
</template>
<script>
export default {
  name: 'ChartsHarvest',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/report/Harvest.vue